export default {
    menu_actions_rename_dashboard: "Renombrar el panel de control",
    menu_actions_delete_dashboard: "Borrar panel de control",
    menu_actions_shared_with_me: "Compartido conmigo",
    menu_actions_reader: "Lector",
    menu_actions_editor: "Editor",
    menu_actions_share: "Compartir",
    menu_actions_share_success_message: "El panel ha sido compartido.",
    menu_actions_share_dashboard: "Compartir panel",
}